<template lang="pug">
  .lang-select
    button.button-lang(
    @click="onShowLangDropDown($event)"
    )
      img(
      v-if="lang === 'RU'"
      src="@/assets/images/languages/ru.png"
      )
      img(
      v-if="lang === 'TAT'"
      src="@/assets/images/languages/tat.png"
      )
    lang-dropdown(
    v-if="showLangDropdown"
    @close="closeLangDropdown"
    :on-choose-lang="chooseLang"
    )
</template>

<script>
import {mapState, mapMutations} from "vuex";
import LangDropdown from "./LangDropdown";

export default {
  name: "LangSelect",
  components: {LangDropdown},
  computed: {
    ...mapState(["translation"])
  },
  props: ["userData", "lang"],
  data() {
    return {
      showLangDropdown: false
    };
  },
  methods: {
    ...mapMutations(["setTranslationData"]),
    onShowLangDropDown(e) {
      e.preventDefault();
      e.stopPropagation();
      this.showLangDropdown = !this.showLangDropdown;
    },
    closeLangDropdown() {
      this.showLangDropdown = false;
    },
    chooseLang(e, lang) {
      e.preventDefault();
      e.stopPropagation();
      this.showLangDropdown = false;
      this.setTranslationData(lang);
    }
  }
};
</script>
